import React from "react";
import { Tooltip } from "antd";
import { observer } from "mobx-react-lite";
import OrderDTO from "@/dto/order/OrderDTO";
import { getTbQnOrderDetailUrl } from "@/scenes/OrderManagement/hooks/useListDecryptedConsignee";
import useSingleOrderDecryptedConsignee from "@/scenes/OrderManagement/hooks/useSingleOrderDecryptedConsignee";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { wangwangService } from "@/services/customerServices";
import { EyeOutlined } from "@ant-design/icons";

interface ConsigneePhoneTbDecryptButtonProps {
    order: OrderDTO;

    onOrderUpdate?(orderId: number, orderData: any): void;
}

const ConsigneePhoneTbDecryptButton: React.FC<ConsigneePhoneTbDecryptButtonProps> = function (props) {
    const { order, onOrderUpdate } = props;

    const orderManagementStore = useOrderManagementStore();

    const { runAsync: handleDecryptedConsignee, loading } = useSingleOrderDecryptedConsignee();

    return (
        <Tooltip
            color="white"
            styles={{ body: {
                width: 450,
                color: "#333",
            } }}
            title={
                <div>
                    <p>
                        1
                        淘宝官方的手机号解密会变成虚拟号，且该接口已升级为付费接口，因此在打单软件内查看解密后的手机虚拟号码需要付费，付费详情
                        <a href={wangwangService.url} target="_blank">
                            请联系客服
                        </a>
                    </p>
                    <p>
                        2 查看手机号码可以前往商家后台免费查看，
                        <a href={getTbQnOrderDetailUrl(order)} target="_blank">
                            点击这里一键跳转后台去查看
                        </a>
                    </p>
                    <p>
                        3 点击
                        <a
                            href={
                                "https://huodong.taobao.com/wow/z/mt/default/HmZpDk4CTanZyJKDeEps?spm=a1zfx5.my_create_page.0.0.fde22251cebrhn"
                            }
                            target="_blank"
                        >
                            了解虚拟号
                        </a>
                    </p>
                </div>
            }
        >
            <EyeOutlined
                className="ml5"
                onClick={async (e) => {
                    e.preventDefault();

                    const results = await handleDecryptedConsignee(order);

                    const result = results?.[0];

                    if (result) {
                        orderManagementStore?.table?.updateOrder(order.id, {
                            consignee: result.consignee,
                        });

                        onOrderUpdate?.(order.id, result);
                    }
                }}
            />
        </Tooltip>
    );
};

export default observer(ConsigneePhoneTbDecryptButton);
